const taxYearToString = (year, offset = 0) => {
  if (!year) return null;
  const yearAsNumber = parseInt(year, 10) + offset;
  return `${yearAsNumber}/${yearAsNumber + 1}`;
};

export default taxYearToString;
